"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalSlug = isLocalSlug;
exports.buildLocalSlug = buildLocalSlug;
function isLocalSlug(slug) {
    return slug.startsWith("local:");
}
function buildLocalSlug(slug) {
    return `local:${slug}`;
}
//# sourceMappingURL=slug.js.map